export default {
  setCourses(state, courses) {
    state.courses = courses;
  },
  setMenuCourses(state, courses) {
    state.menuCourses = courses;
  },
  setCourse(state, course) {
    state.course = course;
  },
  setLastLessons(state, lastLessons) {
    state.lastLessons = lastLessons;
  },
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setRecommendedOptions(state, recommendedOptions) {
    state.recommendedOptions = recommendedOptions;
  },
  setRecommendedHome(state, recommendedHome) {
    state.recommendedHome = recommendedHome;
  },
  setTrails(state, trails) {
    state.trails = trails;
  },
  setMentorship(state, mentorship) {
    state.mentorship = mentorship;
  },
  setPagination(state, pagination) {
    state.pagination = {
      count: pagination.count,
      next: pagination.next,
      previous: pagination.previous,
      current: state.pagination.current
        ? state.pagination.current + pagination.current
        : pagination.current
    };
  },
  setMenuPagination(state, pagination) {
    state.menuPagination = {
      count: pagination.count,
      next: pagination.next,
      previous: pagination.previous,
      current: state.menuPagination.current
        ? state.menuPagination.current + pagination.current
        : pagination.current
    };
  }
};
